import React, { useEffect, useState } from "react";
import {
   FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  FormLabel,
  TextField,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../../../api/DnerhsApi";
import { Link, useParams, useLocation } from "react-router-dom";
import Alert from "../../../../components/Alert";
import ResponseUtils from "../../../../utils/ResponseUtils";
import history from "../../../../utils/History";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    padding: theme.spacing(),
  },
  large: {
    width: theme.spacing(16),
    height: theme.spacing(16),
  },
}));

const initialValuesRadioFields = {
 /* MedicinaClínicaMédica: {
    id:0,
    label: "Medicina Clínica Médica",
    cantidad: "0",
    valor: "no",
  },
  Pediatría: {
    id:0,
    label: "Pediatría",
    cantidad: "0",
    valor: "no",
  },
  Cirugía: {
    id:0,
    label: "Cirugía",
    cantidad: "0",
    valor: "no",
  },
  GinecologíayObstetricia: {
    id:0,
    label: "Ginecología y Obstetricia",
    cantidad: "0",
    valor: "no",
  },
  MedicinaFamiliar: {
    id:0,
    label: "Medicina Familiar",
    cantidad: "0",
    valor: "no",
  },
  LicenEnfermería: {
    id:0,
    label: "Lic. en Enfermería",
    cantidad: "0",
    valor: "no",
  },
  Odontólogos: {
    id:0,
    label: "Odontólogos",
    cantidad: "0",
    valor: "no",
  },
  Bioquímicos: {
    id:0,
    label: "Bioquímicos",
    cantidad: "0",
    valor: "no",
  },
  LicenKinesiologíayFisioterapia: {
    id:0,
    label: "Lic. en Kinesiología y Fisioterapia",
    cantidad: "0",
    valor: "no",
  },
  LicenFarmacia: {
    id:0,
    label: "Lic. en Farmacia",
    cantidad: "0",
    valor: "no",
  },
  Nutricionistas: {
    id:0,
    label: "Nutricionistas",
    cantidad: "0",
    valor: "no",
  },
  Psicólogos: {
    id:0,
    label: "Psicólogos",
    cantidad: "0",
    valor: "no",
  },
  Fonoaudiólogos: {
    id:0,
    label: "Fonoaudiólogos",
    cantidad: "0",
    valor: "no",
  },
  InstrumentadorQuirúrgico: {
    id:0,
    label: "Instrumentador Quirúrgico",
    cantidad: "0",
    valor: "no",
  },*/
}

const Form = () => {
  const classes = useStyles();
  const [isUpdate, setIsUpdate] = useState(false);
  const [responseId, setResponseId] = useState();
  const [radioFields, setRadioFields] = useState(initialValuesRadioFields);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const params = useParams();
  const methods = useForm({});
  const { handleSubmit, } = methods;
  let location = useLocation();

  useEffect(() => {
    const load = () => {
      try {
        getServerData();
        setIsReadOnly(location?.state?.readOnly);
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const getServerData = async () => {
    try {
      const { data: responseEst } = await DnerhsApi.get( `/instituciones/establecimientos/${params.establecimientoId}`);
      if(responseEst){
      const {data : responseProfesionalData} = await DnerhsApi.get(
        `/establecimientos-profesiones/${responseEst.nombreServicio.id}/profesiones`
      );

      console.log('responseProfesionalData', responseProfesionalData);
    
      if (responseProfesionalData) {
        /*let values = { ...radioFields };
        for (let key in radioFields) {
          for (let y in responseProfesionalData) {    
            if(responseProfesionalData[y]?.profesion.descripcion)  {
              let str=responseProfesionalData[y]?.profesion.descripcion.replace(/\./g, '');          
              if (str.split(' ').join('') === key) {
                values[key].id = responseProfesionalData[y].id;
                values[key].valor = "si";
                values[key].cantidad = responseProfesionalData[y].cantidad;
                break;
              } else {
                values[key].valor = "no";
              }
              values[key].cantidad = responseProfesionalData[y].cantidad;
            }
          }
        }*/

        setRadioFields(responseProfesionalData);
        setIsUpdate(true);
        setResponseId(responseProfesionalData.id);
      } 
    }
    } catch (error) {
      console.log(error);
      showMessageError(error);
    }
  };

  const onSubmit = async (data) => {
    try {
      let message;
      let url = "/instituciones/establecimientos/profesionales";

      let payload = {
        institucionEstablecimiento: {
          id: params.establecimientoId,
        }
      };
      for (let key in radioFields) {
        payload[key] = radioFields[key].valor == "si";
        payload[key + "Cantidad"] = parseInt(radioFields[key].cantidad);
      }

      if (isUpdate) {
        payload.id = responseId;
        await DnerhsApi.put(url, {
          ...payload,
        });
        message = "Datos actualizados exitosamente.";
      } else {
        await DnerhsApi.post(url, {
          ...payload,
        });
        message = "Datos guardados exitosamente.";
      }

      Alert.show({
        message,
        type: "success"
      })

      history.goBack();
    } catch (error) {
      console.log(error);
      showMessageError(error);
    }
  };

  const showMessageError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }
    
  const handleRadioChange = (key, value) => {
    setRadioFields((prevState) => {
      let newState = { ...prevState };
      let newValue = newState[key]["valor"] = value;
      if (newValue=== 'no'){
        newState[key]["cantidad"] = "0";
      } 
      return newState;
    });
  };

  const handleCantidadChange = (key, value) => {
    setRadioFields((prevState) => {
      let newState = { ...prevState };
      newState[key]["cantidad"] = parseInt(value);
      return newState;
    });
  };

  return (
    <div>
      <Grid item xs={12}>
        <Typography align="center" variant="h5" color="primary">
          Profesionales del Campo de Práctica
        </Typography>
        <br/> <br/>
      </Grid>
      <div>
        <FormProvider {...methods}>
        <Grid container direction="row" spacing={5}>
          {Object.keys(radioFields).map((key) => {
            let field = radioFields[key];
            return (
              <Grid key={key} item md={4} xs={12}>
                <Card>
                  <CardContent>
                    <Grid container direction="row">
                      <Grid item xs={12} className={classes.field}>
                        <Typography align="center" variant="h6" color="primary">
                          {field.profesion?.descripcion}
                        </Typography>
                      </Grid>
                      <FormLabel align="right" style={{paddingBottom:'10px' }}>Cantidad</FormLabel>
                      <br/> 

                      <Grid item xs={12} className={classes.field}  >
                        <TextField
                          name={field.key}
                          type="number"
                          value={field.cantidad}
                          onChange={(e) =>
                            handleCantidadChange(
                              key,
                              e.target.value
                                .replace(/[^0-9\b]/g, "")
                                .replace("", "0")
                            )
                          }
                          //disabled={isReadOnly || field.valor === "no"}
                          style={{paddingLeft:'5px' }}
                          disabled
                        />
                                    <br/> <br/>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => history.push({
                            pathname: `/profesionales/${params.establecimientoId}/${field.id}`,
                            state: {profesion: `${field.profesion?.descripcion}`}
                          })}
                          disabled={field.valor==="no"}
                        >
                          Profesionales
                        </Button>                        
                      </Grid>                       
                    </Grid>                   
                  </CardContent>                  
                </Card>
              </Grid>
            );
          })}
        </Grid>
        </FormProvider>
      </div>

      <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        <Grid item className={classes.field}>
          <Button
            variant="contained"
            color="default"
            onClick = {() => history.goBack()}
          >
           Atrás
          </Button>
        </Grid>
        
      </Grid>
    </div>
  );
};

export default Form;
